import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { 
  Button, AppBar, Toolbar, IconButton, Drawer, List, 
  ListItem, ListItemText, ListItemIcon, Tooltip, Box, Typography, Divider,
  BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme,
  Avatar
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import KebabDiningIcon from '@mui/icons-material/KebabDining';
import CloseIcon from '@mui/icons-material/Close';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import StoreIcon from '@mui/icons-material/Store';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ReceiptIcon from '@mui/icons-material/Receipt';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ErrorIcon from '@mui/icons-material/Error';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';

import { registrarAccion, isAuthenticated } from '../services/api.js';
import './estilos.css';
import {
  COLORSISTEMA,
  ICON_COLOR,
} from "../services/apiConfig";

const MenuItemsConfig = {
  1: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Usuarios", icon: <PersonIcon />, route: "/userList" },
    { title: "Productos", icon: <ArtTrackIcon />, route: "/productoList" },
    { title: "Carta", icon: <PictureAsPdfIcon />, route: "/Carta" },
    { title: "Sucursales", icon: <StoreIcon />, route: "/sucursalesList" },
    { title: "Cupones", icon: <ReceiptIcon />, route: "/CuponesList" },
    { title: "Ventas", icon: <ShoppingCartIcon />, route: "/ventas" },
    { title: "Nueva Venta", icon: <PointOfSaleIcon />, route: "/ventanueva" },
    { title: "Mesas", icon: <TableRestaurantIcon />, route: "/mesas" },
    { title: "Análisis", icon: <BarChartIcon />, route: "/analisis" },
    { title: "Pedidos", icon: <KebabDiningIcon />, route: "/pedidosList" },
    { title: "Facturación ARCA", icon: <ReceiptLongIcon />, route: "/facturacionconfig" },
    { title: "Usuarios acciones", icon: <CleaningServicesIcon />, route: "/UsuarioAccionesList" },
    { title: "Auditoría de cambios", icon: <VerifiedUserIcon />, route: "/AuditoriaList" },
    { title: "Errores", icon: <ErrorIcon />, route: "/ErroresList" },
    //{ title: "Configuración", icon: <SettingsIcon />, route: "/settings" },
  ],
  2: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Productos", icon: <ArtTrackIcon />, route: "/productoList" },
    { title: "Ventas", icon: <ShoppingCartIcon />, route: "/ventas" },
    { title: "Nueva Venta", icon: <PointOfSaleIcon />, route: "/ventanueva" },
   // { title: "Mesas", icon: <TableRestaurantIcon />, route: "/mesas" },
    
    { title: "Pedidos", icon: <KebabDiningIcon />, route: "/pedidosList" },
    { title: "Análisis", icon: <BarChartIcon />, route: "/analisis" },
  ],
  3: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Nueva Venta", icon: <PointOfSaleIcon />, route: "/ventanueva" },
    { title: "Ventas", icon: <ShoppingCartIcon />, route: "/ventas" },
  ],
};

// Menús principales para navegación móvil (bottom nav)
const MobileMainMenuConfig = {
  1: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Productos", icon: <ArtTrackIcon />, route: "/productoList" },
    { title: "Ventas", icon: <ShoppingCartIcon />, route: "/ventas" },
    { title: "Vender", icon: <PointOfSaleIcon />, route: "/ventanueva" },
    { title: "Más", icon: <MoreVertIcon />, route: "more" },
  ],
  2: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Productos", icon: <ArtTrackIcon />, route: "/productoList" },
    { title: "Pedidos", icon: <KebabDiningIcon />, route: "/pedidosList" },
    { title: "Vender", icon: <PointOfSaleIcon />, route: "/ventanueva" },
  ],
  3: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Vender", icon: <PointOfSaleIcon />, route: "/ventanueva" },
    { title: "Ventas", icon: <ShoppingCartIcon />, route: "/ventas" },
  ],
};

export const MenuInicial = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Detecta móvil/tablet
  
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const perfil = userData?.perfil || 3;
  const auditaroperaciones = userData?.auditaroperaciones;
  const usuarioid = userData?.usuarioid;
  const nombreUsuario = userData?.username || userData?.nombre || "Usuario";
  const sucursalNombre = userData?.sucursalnombre || "Sucursal"; 
  
  const [open, setOpen] = useState(false);
  const [bottomNavValue, setBottomNavValue] = useState(0);
  
  const currentMenuItems = MenuItemsConfig[perfil] || MenuItemsConfig[3];
  const mobileMainMenu = MobileMainMenuConfig[perfil] || MobileMainMenuConfig[3];

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/login");
    }
  }, [navigate]);

  // Actualizar valor de bottom navigation según la ruta actual
  useEffect(() => {
    const currentIndex = mobileMainMenu.findIndex(item => item.route === location.pathname);
    if (currentIndex !== -1) {
      setBottomNavValue(currentIndex);
    }
  }, [location, mobileMainMenu]);

  const handleNavigation = async (destination) => {
    if (Number(auditaroperaciones) === 1) {
      await registrarAccion(usuarioid, ` navegó a ${destination}`);
    }
    navigate(destination);
    setOpen(false);
};

  // Renderizado para MÓVIL/TABLET
  if (isMobile) {
    return (
      <>
        {/* Header minimalista para móvil */}
        <AppBar 
          position="fixed" 
          sx={{ 
            backgroundColor: COLORSISTEMA,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          <Toolbar sx={{ minHeight: '56px !important' }}>
            <IconButton edge="start" color="inherit" onClick={() => setOpen(true)}>
              <MenuIcon sx={{ color: ICON_COLOR }} />
            </IconButton>
            
            <Box sx={{ flexGrow: 1, ml: 2 }}>
              <Typography variant="h6" sx={{ color: 'white', fontWeight: '600', fontSize: '1.1rem' }}>
                Gestion de Locales
              </Typography>
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.7rem' }}>
                {sucursalNombre}
              </Typography>
            </Box>

            <Avatar 
              sx={{ 
                width: 32, 
                height: 32, 
                bgcolor: ICON_COLOR,
                fontSize: '0.9rem'
              }}
            >
              {nombreUsuario.charAt(0).toUpperCase()}
            </Avatar>
          </Toolbar>
        </AppBar>

        {/* Spacer para que el contenido no quede debajo del AppBar */}
        <Toolbar sx={{ minHeight: '56px !important' }} />

        {/* Bottom Navigation */}
        <Paper 
          sx={{ 
            position: 'fixed', 
            bottom: 0, 
            left: 0, 
            right: 0, 
            zIndex: 1000,
            borderTop: '1px solid rgba(0,0,0,0.12)'
          }} 
          elevation={3}
        >
          <BottomNavigation
            value={bottomNavValue}
            onChange={(event, newValue) => {
              setBottomNavValue(newValue);
              const selectedItem = mobileMainMenu[newValue];
              if (selectedItem.route === "more") {
                setOpen(true);
              } else {
                handleNavigation(selectedItem.route);
              }
            }}
            showLabels
            sx={{
              height: 65,
              '& .MuiBottomNavigationAction-root': {
                minWidth: 'auto',
                padding: '6px 0',
              },
              '& .Mui-selected': {
                color: COLORSISTEMA,
              },
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.7rem',
                marginTop: '4px'
              }
            }}
          >
            {mobileMainMenu.map((item, index) => (
              <BottomNavigationAction
                key={index}
                label={item.title}
                icon={React.cloneElement(item.icon, { 
                  sx: { 
                    fontSize: '1.5rem',
                    color: bottomNavValue === index ? COLORSISTEMA : 'rgba(0,0,0,0.6)'
                  } 
                })}
              />
            ))}
          </BottomNavigation>
        </Paper>

        {/* Drawer lateral con todas las opciones */}
        <Drawer 
          anchor="left" 
          open={open} 
          onClose={() => setOpen(false)}
          sx={{
            '& .MuiDrawer-paper': {
              width: 280,
            }
          }}
        >
          <Box>
            {/* Header del drawer */}
            <Box 
              sx={{ 
                p: 3, 
                background: `linear-gradient(135deg, ${COLORSISTEMA} 0%, ${COLORSISTEMA}dd 100%)`,
                color: 'white',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar 
                  sx={{ 
                    width: 50, 
                    height: 50, 
                    bgcolor: ICON_COLOR,
                    mr: 2,
                    fontSize: '1.3rem'
                  }}
                >
                  {nombreUsuario.charAt(0).toUpperCase()}
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: '600' }}>
                    {nombreUsuario}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.9 }}>
                    {perfil === 1 ? 'Administrador' : perfil === 2 ? 'Gerente' : 'Vendedor'}
                  </Typography>
                </Box>
              </Box>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                📍 {sucursalNombre}
              </Typography>
            </Box>

            {/* Lista de opciones */}
            <List sx={{ pt: 1 }}>
              {currentMenuItems.map((item, index) => (
                <ListItem 
                  button 
                  key={index} 
                  onClick={() => handleNavigation(item.route)}
                  sx={{
                    py: 1.5,
                    '&:hover': {
                      backgroundColor: `${COLORSISTEMA}10`,
                    },
                    borderLeft: location.pathname === item.route ? `4px solid ${COLORSISTEMA}` : '4px solid transparent',
                  }}
                >
                  <ListItemIcon>
                    {React.cloneElement(item.icon, { 
                      sx: { 
                        color: location.pathname === item.route ? COLORSISTEMA : 'rgba(0,0,0,0.6)',
                        fontSize: '1.4rem'
                      } 
                    })}
                  </ListItemIcon>
                  <ListItemText 
                    primary={item.title}
                    primaryTypographyProps={{
                      fontSize: '0.95rem',
                      fontWeight: location.pathname === item.route ? '600' : '400',
                      color: location.pathname === item.route ? COLORSISTEMA : 'inherit'
                    }}
                  />
                </ListItem>
              ))}
              
              <Divider sx={{ my: 1 }} />
              
              {/* Cerrar Sesión */}
              <ListItem 
                button 
                onClick={() => handleNavigation("/logout")}
                sx={{
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: 'rgba(211, 47, 47, 0.08)',
                  }
                }}
              >
                <ListItemIcon>
                  <CloseIcon sx={{ color: '#d32f2f', fontSize: '1.4rem' }} />
                </ListItemIcon>
                <ListItemText 
                  primary="Cerrar Sesión"
                  primaryTypographyProps={{
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    color: '#d32f2f'
                  }}
                />
              </ListItem>
            </List>
          </Box>
        </Drawer>

        {/* Spacer para que el contenido no quede debajo del bottom nav */}
        <Box sx={{ height: 65 }} />
      </>
    );
  }

  // Renderizado para DESKTOP (tu menú actual)
  return (
    <Box className="miDiv">
      <AppBar position="static" style={{ backgroundColor: COLORSISTEMA }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
          
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', ml: 2 }}>
            {currentMenuItems.map((item, index) => (
              <Button 
                key={index} 
                variant="text" 
                onClick={() => handleNavigation(item.route)} 
                sx={{ 
                  color: '#ffffff', 
                  minWidth: '50px',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
                }}
              >
                <Tooltip title={item.title}>
                  {React.cloneElement(item.icon, { sx: { color: ICON_COLOR } })}
                </Tooltip>
              </Button>
            ))}
          </Box>
          
          <Typography variant="body1" sx={{ color: 'white', mr: 2, fontWeight: '500' }}>
            Hola, {nombreUsuario}
          </Typography>
          
          <Button variant="text" onClick={() => handleNavigation("/logout")} style={{ color: '#ffffff' }}>
            <Tooltip title="Cerrar sesión"><CloseIcon sx={{ color: ICON_COLOR }} /></Tooltip>
          </Button>
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 250 }}>
          <Box sx={{ p: 2, backgroundColor: COLORSISTEMA, color: 'white', textAlign: 'center' }}>
            <AccountCircleIcon sx={{ fontSize: 40, mb: 1, color: ICON_COLOR }} />
            <Typography variant="h6">Hola, {nombreUsuario}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              Perfil: {perfil === 1 ? 'Admin' : perfil === 2 ? 'Gerente' : 'Vendedor'}
            </Typography>
          </Box>
          <Divider />
          
          <List>
            {currentMenuItems.map((item, index) => (
              <ListItem button key={index} onClick={() => handleNavigation(item.route)}>
                <ListItemIcon>
                  {React.cloneElement(item.icon, { sx: { color: COLORSISTEMA } })}
                </ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItem>
            ))}
            <Divider />
            <ListItem button onClick={() => handleNavigation("/logout")}>
              <ListItemIcon><CloseIcon sx={{ color: 'red' }} /></ListItemIcon>
              <ListItemText primary="Cerrar Sesión" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default MenuInicial;
